import { Container } from '@radix-ui/themes'

import Credit from '../interfaces/Credit'
import { useAuth } from '../hooks/useAuth'
import { VehicleBasePic } from '../interfaces/Vehicle'
import ClientBase from '../interfaces/ClientBase'
import { formatCurrency, formatIsoToDDMMYYYY } from '../utils/utils'
import { truncateToTwoDecimals } from '../utils/handleInputChangeFormat'

import { RadioItem } from './RadioGroup'
import { DisplayValueFormat } from './DisplayValue'
import { DocHeader } from './DocHeader'
import { OrganizationFrame, OrganizationFrameType } from './OrganizationFrame'
import { ClientFrame, ClientFrameType } from './ClientFrame'
import { VehicleFrame, VehicleFrameType } from './VehicleFrame'
import DocFooter from './DocFooter'
import { ButtonAction, ButtonPrint } from './Buttons'
import { PrintableCard } from './PrintableCard'

interface CreditEx extends Credit {
  amount_format: string
  fee_format: string
  observations_format: string
  // paymentsQty_format: string,
  paymentsAmount_format: string
  rate_format: string
  salary_format: string
}
export type CreditFormat = Omit<CreditEx, 'vehicle' | 'client'>

const tipoCreditoGroup: RadioItem[] = [{ label: 'Convencional' }, { label: 'Compra inteligente' }]

const CreditPreview: React.FC<{
  vehicle: VehicleBasePic
  client: ClientBase
  credit: CreditFormat
  onGoBack: () => void
}> = ({ vehicle, client, credit, onGoBack }) => {
  const { userData } = useAuth()
  const myNumberRes = ''
  const docHeader = {
    urlImage: userData?.organization?.pictures.logotype ?? '',
    titulo: `Solicitud de crédito ${myNumberRes}`,
    //  isAnulada: !!credit?.status,
    isAnulada: false,
    tituloAnulada: 'NULA',
    fechaIniText: `Fecha`,
    fechaIniValue: formatIsoToDDMMYYYY(credit?.createdAt),
    fechaFinText: '',
    fechaFinValue: '',
  }

  const clientName = `${client.firstname ?? ''} ${client.lastname ?? ''}`

  const profile_name = credit.profile_name ?? ''
  const names = {
    profileName: profile_name,
    organizationName: credit.body?.organization.name ?? '',
    clientName: clientName,
  }
  const myOrg = credit.body?.organization
  const organizationFrame: OrganizationFrameType = {
    nin: myOrg?.nin,
    phone: myOrg?.phone,
    email: myOrg?.email,
    domain: myOrg?.domain,
    address: myOrg?.address,
    name: myOrg?.name,
    business: myOrg?.business,
    user: { name: profile_name, phone: credit.user_phone ?? '' },
  }

  const clientFrame: ClientFrameType = {
    ...client,
    name: clientName,
  }
  const vehicleFrame: VehicleFrameType = {
    ...vehicle,
  }
  const tipoCredito = tipoCreditoGroup[credit.type ?? 0].label
  // El porcentaje del credito sobre el precio de venta
  let percentage = 0
  const creditPrice = credit?.price ?? 0

  if (creditPrice > 0) {
    percentage = ((credit?.amount ?? 0) / creditPrice) * 100
  }
  const decimalChar = '.'
  const numericValue = percentage.toString()
  const formatted = truncateToTwoDecimals(numericValue, decimalChar).replace('.', ',')

  return (
    <Container size="3">
      <PrintableCard>
        <DocHeader header={docHeader} />
        <hr className="w-full border-t border-black-500 my-2" />
        <OrganizationFrame organization={organizationFrame} />

        <hr className="w-full border-t border-black-500 my-2" />
        <ClientFrame client={clientFrame} />

        <hr className="w-full border-t border-black-500 my-2" />
        <VehicleFrame vehicle={vehicleFrame} noPrice={true} />

        <hr className="w-full border-t border-black-500 my-2" />
        <div>
          <div className="mb-2">
            <span className="text-2xl">Datos del Crédito</span>
          </div>
          <div className="grid grid-cols-4   mt-4">
            <DisplayValueFormat label="Institución" value={credit?.institution} />
            <DisplayValueFormat label="Tipo de crédito" value={tipoCredito} />
            <DisplayValueFormat label="Precio de venta" value={formatCurrency(credit?.price ?? 0)} />
            <DisplayValueFormat label="Monto a financiar" value={formatCurrency(credit?.amount)} />
            <DisplayValueFormat label="% Monto a financiar" value={`${formatted}%`} />
            <DisplayValueFormat label="Cantidad de cuotas" value={credit?.paymentsQty} />
            <DisplayValueFormat label="Monto de la cuota" value={formatCurrency(credit?.paymentsAmount ?? 0)} />
            <DisplayValueFormat label="Tasa de interés" value={`${credit?.rate_format}%`} />
            <DisplayValueFormat label="Comisión" value={formatCurrency(credit?.fee ?? 0)} />
            <DisplayValueFormat
              label="Sueldo líquido del cliente"
              value={
                credit.autofinData?.DatosCliente?.Renta
                  ? formatCurrency(credit.autofinData.DatosCliente.Renta)
                  : `${credit?.salary_format}`
              }
            />
          </div>
          <div className="flex gap-4">
            <DisplayValueFormat label="Notas:" value={credit?.observations_format} />
          </div>
        </div>
        <DocFooter names={names} />
      </PrintableCard>
      <div className="flex justify-center mt-4 mb-4">
        <ButtonPrint />
        <div className="ml-2 print:hidden">
          <ButtonAction label="Volver a la solicitud" handleButtonClick={onGoBack} />
        </div>
      </div>
    </Container>
  )
}
export default CreditPreview
